import { cn } from "@/lib/utils";
import { useLanguage } from "@/lib/language";

export function LanguageSelector({ className }) {
  const { language, setLanguage } = useLanguage();
  return (
    <div
      className={cn("inline-flex rounded-full bg-[#E3EDD9] p-1", className)}
      aria-label="Language selector"
      data-testid="language-selector"
    >
      <button
        type="button"
        onClick={() => setLanguage("id")}
        className={cn(
          "min-w-9 rounded-full px-2 py-1 text-[11px] font-extrabold transition-colors",
          language === "id" ? "bg-[#1A3323] text-[#FDFCF8]" : "text-[#1A3323]/65"
        )}
        aria-pressed={language === "id"}
        data-testid="language-id-button"
      >
        ID
      </button>
      <button
        type="button"
        onClick={() => setLanguage("en")}
        className={cn(
          "min-w-9 rounded-full px-2 py-1 text-[11px] font-extrabold transition-colors",
          language === "en" ? "bg-[#1A3323] text-[#FDFCF8]" : "text-[#1A3323]/65"
        )}
        aria-pressed={language === "en"}
        data-testid="language-en-button"
      >
        EN
      </button>
    </div>
  );
}